import styled from 'styled-components';
import { normalize } from 'utils/styles';
import { ReactComponent as _ZoomIn } from 'styles/icons/zoom-in.svg';
import { ReactComponent as _ZoomOut } from 'styles/icons/zoom-out.svg';
import { color, media, typography } from 'styles/settings';

export const Container = styled.div`
  display: flex;
  margin: 0 ${normalize('-32px')};
  margin-top: ${normalize('-30px')};
  height: 100%;
  position: relative;
  ${media.mediaQueries.mobile`
  margin: 0 ${normalize('0px')};
  margin-top: ${normalize('0px')};
  `}
`;

export const ZoomIn = styled(_ZoomIn)`
  width: 18px;
  height: 18px;
  background-color: ${color.neutral.plainBlack};
  color: ${color.neutral.white};
  border-radius: 100%;
  padding: 10px;
  cursor: pointer;
`;

export const ZoomOut = styled(_ZoomOut)`
  width: 18px;
  height: 18px;
  background-color: ${color.neutral.plainBlack};
  color: ${color.neutral.white};
  border-radius: 100%;
  padding: 10px;
  cursor: pointer;
`;

export const Controls = styled.div`
  ${typography.font.content.semiBold};
  font-size: ${typography.size.sm};
  width: 98%;
  position: absolute;
  bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  left: 1%;

  > :last-child {
    width: 300px;
    display: flex;
    justify-content: space-between;
  }

  form {
    display: inline;
  }
`;
